<template>
  <form>
      <div class="row q-col-gutter-md">
        <div class="col-12">
            <q-select
                v-model="VerificationTypeObj.country_id"
                :label="$t('verification-types.table_titles.country')"
                emit-value
                map-options
                option-value="id"
                option-label="name"
                :options="countries"
                :loading="loading"
                :error="VerificationTypeObj.errors.has('country_id')"
                :error-message="VerificationTypeObj.errors.get('country_id')"
                :rules="[ val => val && val > 0 || $t('verification-types.table_titles.country') + ' is required!']"
                color="input-color"
            >
                <template v-slot:option="scope">
                    <q-item
                        v-bind="scope.itemProps"
                        v-on="scope.itemEvents"
                        style="border-bottom:1px solid #999"
                    >
                        <q-item-section avatar>
                            <q-icon :name="scope.opt.acronym" size="36px" />
                        </q-item-section>
                        <q-item-section>
                            <q-item-label>{{scope.opt.name}}</q-item-label>
                        </q-item-section>
                    </q-item>
                </template>
            </q-select>
        </div> <!-- COUNTRY ID -->
        <div class="col col-xs-12 col-md-6 col-lg-6">
            <q-select
                v-model="VerificationTypeObj.communication_type"
                :label="$t('verification-types.table_titles.communication_type')"
                :options="communication_types"
                :error="VerificationTypeObj.errors.has('communication_type')"
                :error-message="VerificationTypeObj.errors.get('communication_type')"
                color="input-color"
            />
        </div> <!-- COMMUNICATION TYPE -->
        <div class="col col-xs-12 col-md-6 col-lg-6">
            <q-input
                v-model="VerificationTypeObj.kyc_method"
                :label="$t('verification-types.table_titles.kyc_method')"
                :error="VerificationTypeObj.errors.has('kyc_method')"
                :error-message="VerificationTypeObj.errors.get('kyc_method')"
                color="input-color"
            />
        </div> <!-- KYC METHOD -->
        <div class="col-12">
            <p class="text-bolder">{{$t('verification-types.table_titles.instructions')}}:</p>
              <q-editor
                  v-model="VerificationTypeObj.instructions"
                  :dense="$q.screen.lt.md"
                  :error="VerificationTypeObj.errors.has('instructions')"
                  :error-message="VerificationTypeObj.errors.get('instructions')"
                  :toolbar="[
                        [
                            {
                              label: $q.lang.editor.align,
                              icon: $q.iconSet.editor.align,
                              fixedLabel: true,
                              options: ['left', 'center', 'right', 'justify']
                            }
                        ],
                        ['bold', 'italic', 'strike', 'underline'],
                        ['hr', 'link'],
                        ['foreColor', 'backColor'],
                        ['unordered', 'ordered'],
                        ['fields'],
                        ['removeFormat', 'viewsource'],
                        ['undo', 'redo']
                    ]"
                  :fonts="{
                        arial: 'Arial',
                        arial_black: 'Arial Black',
                        comic_sans: 'Comic Sans MS',
                        courier_new: 'Courier New',
                        impact: 'Impact',
                        lucida_grande: 'Lucida Grande',
                        times_new_roman: 'Times New Roman',
                        verdana: 'Verdana'
                    }"
              />
        </div> <!-- INSTRUCTIONS -->
        <div class="col-12">
            <p class="text-bolder">{{$t('verification-types.table_titles.dialog_content')}}:</p>
              <q-editor
                  v-model="VerificationTypeObj.dialog_content"
                  :dense="$q.screen.lt.md"
                  :error="VerificationTypeObj.errors.has('dialog_content')"
                  :error-message="VerificationTypeObj.errors.get('dialog_content')"
                  :toolbar="[
                        [
                            {
                              label: $q.lang.editor.align,
                              icon: $q.iconSet.editor.align,
                              fixedLabel: true,
                              options: ['left', 'center', 'right', 'justify']
                            }
                        ],
                        ['bold', 'italic', 'strike', 'underline'],
                        ['hr', 'link'],
                        ['foreColor', 'backColor'],
                        ['unordered', 'ordered'],
                        ['fields'],
                        ['removeFormat', 'viewsource'],
                        ['undo', 'redo']
                    ]"
                  :fonts="{
                        arial: 'Arial',
                        arial_black: 'Arial Black',
                        comic_sans: 'Comic Sans MS',
                        courier_new: 'Courier New',
                        impact: 'Impact',
                        lucida_grande: 'Lucida Grande',
                        times_new_roman: 'Times New Roman',
                        verdana: 'Verdana'
                    }"
              />
        </div> <!-- DIALOG CONTENT -->
        <div class="col-12">
            <p class="text-bolder">{{$t('verification-types.table_titles.on_review_email_content')}}:</p>
              <q-editor
                  v-model="VerificationTypeObj.on_review_email_content"
                  :dense="$q.screen.lt.md"
                  :error="VerificationTypeObj.errors.has('on_review_email_content')"
                  :error-message="VerificationTypeObj.errors.get('on_review_email_content')"
                  :toolbar="[
                        [
                            {
                              label: $q.lang.editor.align,
                              icon: $q.iconSet.editor.align,
                              fixedLabel: true,
                              options: ['left', 'center', 'right', 'justify']
                            }
                        ],
                        ['bold', 'italic', 'strike', 'underline'],
                        ['hr', 'link'],
                        ['foreColor', 'backColor'],
                        ['unordered', 'ordered'],
                        ['fields'],
                        ['removeFormat', 'viewsource'],
                        ['undo', 'redo']
                    ]"
                  :fonts="{
                        arial: 'Arial',
                        arial_black: 'Arial Black',
                        comic_sans: 'Comic Sans MS',
                        courier_new: 'Courier New',
                        impact: 'Impact',
                        lucida_grande: 'Lucida Grande',
                        times_new_roman: 'Times New Roman',
                        verdana: 'Verdana'
                    }"
              />
        </div> <!-- ON REVIEW EMAIL CONTENT -->
      </div>
    </form>
</template>

<script>
import {InitializingCountriesMixin} from "Modules/Region/resources/mixins/InitializingCountriesMixin"

export default {
  name: 'Form',
    mixins: [ InitializingCountriesMixin ],
  model: {
    prop: 'VerificationTypeObj',
    event: 'change'
  },
  props: {
    VerificationTypeObj: {
      type: Object,
      required: true
    }
  },
  computed: {},
  data() {
    return {
        loading: false,
        communication_types: ['sms', 'email']
    }
  },
  methods: {},
  components: {},
}
</script>

<style scoped>

</style>
